import { useState, useEffect } from "react";
import axios from "axios";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Unstable_Grid2";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { toast } from "react-toastify";
import { DistrictApi } from "apis/DistrictApi";
import { StatesApi } from "apis/StatesApi";
import DistrictTable from "components/Tables/DistrictTable";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import { useNavigate } from "react-router";
import TableHeader from "components/Table/TableHeader";
import TableElement from "components/Table/TableElement";
import { Pagination, useMediaQuery } from "@mui/material";
import { ActionButton, Toolbar, TableCard, FormCard } from "utils/ui";

function District() {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:768px)");
  const [district, setDistrict] = useState([]);
  const [totalPages, setTotalPages] = useState();
  const [states, setStates] = useState([]);
  const [open, setOpen] = useState(false);
  const [districtData, setDistrictData] = useState({
    id: "",
    name: "",
    isActive: true,
    state: {
      id: "",
      name: "",
      code: "",
      isActive: true,
    },
  });
  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "id") {
      setDistrictData({
        ...districtData,
        state: {
          ...districtData.state,
          id: value,
        },
      });
    } else {
      setDistrictData({
        ...districtData,
        [name]: value,
      });
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleSave = () => {
    DistrictApi.AddDistrict(districtData)
      .then((res) => {
        toast("District Added", {
          type: "success",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        setOpen(false);
      })
      .catch((err) => {
        if (err?.response?.data) {
          toast(err.response.status + " " + err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        } else {
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        }
        if (err.response.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };

  const getDistricts = () => {
    DistrictApi.GetDistrictsListByFilter({
      stateId: null,
    })
      .then((res) => {
        setDistrict(res.data.data);
        setTotalPages(res.data.totalPages);
      })
      .catch((err) => {
        if (err?.response?.data) {
          toast(err.response.status + " " + err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        } else {
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        }
        if (err.response.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };
  const getStates = () => {
    StatesApi.GetStatesListByFilter()
      .then((res) => {
        setStates(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data) {
          toast(err.response.status + " " + err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        } else {
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        }
        if (err.response.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };
  const [selectedState, setSelectedState] = useState("");

  const handleChangeState = (event) => {
    const stateId = event.target.value;
    setSelectedState(stateId);
    handleSelectState(stateId);
  };
  const [filteredDistricts, setFilteredDistricts] = useState([]);

  const handleSelectState = (stateId) => {
    const filtered = district.filter((d) => d.state.id === stateId);
    setFilteredDistricts(filtered);
  };
  const handleResetFilter = () => {
    setSelectedState("");
    setFilteredDistricts(district);
  };

  useEffect(() => {
    axios.defaults.headers.common["x-api-key"] =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxOTU4NDk0NDY3NDY0MzE1NjQ5ODc0NTY0ODkyNiIsIm5hbWUiOiJTY2hlbWVzIEJvb29rIiwiaWF0IjoxNTE2MjM5MDIyfQ.uVUOR2U82nTjNccumsyggdScQh0DA5PdlwF_l0VUdfd";
    axios.defaults.headers.common["Authorization"] =
      localStorage.getItem("token");
    getDistricts();
    getStates();
  }, []);
  const [currentPage, setCurrentPage] = useState(1);
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    getDistricts(value);
  };
  useEffect(() => {
    setFilteredDistricts(district);
  }, [district]);

  return (
    <>
      <FormCard>
        <Toolbar>
          <ActionButton icon="fas fa-plus" onClick={handleClickOpen}>
            Add District
          </ActionButton>
        </Toolbar>
      </FormCard>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Add District</DialogTitle>
        <DialogContent sx={{ p: { xs: 2, sm: 3 } }}>
          <Grid container spacing={2}>
            <Grid xs={6} md={6}>
              <TextField
                id="outlined-basic"
                sx={{ m: 2 }}
                label="Name"
                name="name"
                variant="outlined"
                value={districtData.name}
                onChange={handleChange}
              />
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">State</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  value={districtData.state.id}
                  label="State"
                  onChange={handleChange}
                  sx={{ m: 2 }}
                  name="id"
                >
                  {states.map((i, index) => {
                    if (i.name) {
                      return (
                        <MenuItem key={index} value={i.id}>
                          {i.name}
                        </MenuItem>
                      );
                    }
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={6} md={6}>
              <FormControl sx={{ m: 2 }}>
                <FormLabel id="demo-controlled-radio-buttons-group">
                  IsActive
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group"
                  name="isActive"
                  value={districtData.isActive}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="True"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="False"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSave}>Save</Button>
        </DialogActions>
      </Dialog>

      <FormCard>
        <Toolbar>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Filter District by State
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              value={selectedState}
              onChange={handleChangeState}
              sx={{ m: 2 }}
            >
              {states.map((i, index) => {
                if (i.name) {
                  return (
                    <MenuItem key={index} value={i.id}>
                      {i.name}
                    </MenuItem>
                  );
                }
              })}
            </Select>
          </FormControl>
          <ActionButton color="secondary" onClick={handleResetFilter}>
            Reset All
          </ActionButton>
        </Toolbar>
      </FormCard>

      <TableCard>
        <div className="p-0">
          <div className="mb-2 flex justify-center">
            <Pagination
              count={totalPages}
              page={currentPage}
              color="primary"
              onChange={handlePageChange}
              size={isMobile ? "small" : "medium"}
              className="mb-4"
            />
          </div>
          <div className="overflow-x-auto">
          <table className="w-full border-collapse" style={{ minWidth: 500 }}>
            <thead>
              <tr>
                <TableHeader heading="" />
                <TableHeader heading="Name" />
                <TableHeader heading="State" />
                <TableHeader heading="Is Active" />
              </tr>
            </thead>
            <tbody>
              {filteredDistricts?.map((d, i) => {
                return (
                  <tr
                    key={i}
                    style={{ transition:"background 100ms" }} onMouseEnter={(e)=>e.currentTarget.style.background="#F8FAFC"} onMouseLeave={(e)=>e.currentTarget.style.background="transparent"}
                  >
                    <TableElement value={i + 1} />
                    <TableElement value={d.name} />
                    <TableElement value={d?.state?.name} />
                    <TableElement value={d.isActive} type="boolean" />
                  </tr>
                );
              })}
            </tbody>
          </table>
          </div>
        </div>
      </TableCard>
    </>
  );
}

export default District;
